import { defineComponent as _defineComponent } from 'vue';
import {} from "@fortawesome/fontawesome-svg-core";
import { faQuestion } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { computed } from "vue";
import { useRouter } from "vue-router/composables";
import { useActivityStore } from "@/stores/activityStore";
import localize from "@/utils/localization";
import TextShort from "@/components/Common/TextShort.vue";
import Popper from "@/components/Popper/Popper.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ActivityItem',
    props: {
        id: null,
        activityBarId: null,
        title: { default: undefined },
        icon: { default: () => faQuestion },
        indicator: { default: 0 },
        isActive: { type: Boolean, default: false },
        tooltip: { default: undefined },
        tooltipPlacement: { default: "right" },
        progressPercentage: { default: 0 },
        progressStatus: { default: undefined },
        options: { default: undefined },
        to: { default: undefined },
        variant: { default: "primary" }
    },
    emits: ["click"],
    setup(__props, { emit }) {
        const props = __props;
        const router = useRouter();
        function onClick(evt) {
            emit("click");
            if (props.to) {
                router.push(props.to);
            }
        }
        const store = useActivityStore(props.activityBarId);
        const meta = computed(() => store.metaForId(props.id));
        return { __sfc: true, router, props, emit, onClick, store, meta, FontAwesomeIcon, localize, TextShort, Popper };
    }
});
